export enum GatewayRequestType {
  Login = 'Login',
  Ping = 'Ping',

  GetLatestNewsArticlesBySymbols = 'GetLatestNewsArticlesBySymbols',
  GetLatestNewsArticles = 'GetLatestNewsArticles',
  MarketDataSubscribeNbbo = 'MarketDataSubscribeNbbo',
  MarketDataSubscribeTrade = 'MarketDataSubscribeTrade',
  MarketDataSummary = 'MarketDataSummary',
  InstrumentSnapshot = 'InstrumentSnapshot',
  MarketDataSubscribeSymbolStatus = 'MarketDataSubscribeSymbolStatus',
  MarketDataQuery = 'MarketDataQuery',

  // Order
  NewOrderRequest = 'NewOrderRequest',
  ModifyOrderRequest = 'ModifyOrderRequest',
  CancelOrderRequest = 'CancelOrderRequest',

  // unsubscribe
  MarketDataUnsubscribeSymbolStatus = 'MarketDataUnsubscribeSymbolStatus',
  MarketDataUnsubscribeNbbo = 'MarketDataUnsubscribeNbbo',
  MarketDataUnsubscribeTrade = 'MarketDataUnsubscribeTrade',

  None = '',
}

export enum GatewayResponseType {
  Login = 'Login',
  DataSummaryResponse = 'DataSummaryResponse',
  DataQueryResponse = 'DataQueryResponse',
  MarketDataQuery = 'MarketDataQuery',
  InstrumentSnapshot = 'InstrumentSnapshot',
  Subscriptions = 'Subscriptions',

  // Order
  ExecutionReport = 'ExecutionReport',
  OrderRejectedResponse = 'OrderRejectedResponse',
  ModifyOrCancelReject = 'ModifyOrCancelReject',

  Error = 'Error',
  Pong = 'Pong',

  MarketData = 2,
}

export enum GatewayResponseSubType {
  Trade = 3,
  Nbbo = 5,
  SymbolStatus = 14
}

export enum KeepAliveMode {
  Application = 'Application',
}
